import * as React from "react";
import { connect } from 'react-redux';
import './IveriSuccessLoadingScreen.css'
//@ts-ignore
import animationData from './Capture-credit-card-ani01.json';
import Lottie from 'react-lottie';
import { LOADING_SCREEN_COPY, LOADING_COPY_CRUNCHING_NUMBERS, ERROR_SOMETHING_WENT_WRONG } from "../../constants/copy";

class IveriSuccessLoadingScreen extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            render: false,
            isError: false,
            isLoading: false,
            IsCrunchingNumbers: false,
            isStopped: false,
            isPaused: false
        }
        this.handleResize = this.handleResize.bind(this);
        window.addEventListener('resize', this.handleResize)
    }

    handleResize() {
        this.setState({ render: !this.state.render })
    }

    render() {

        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: animationData,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        };

        let lottieSize = 300;

        if (window.innerWidth <= 300) {
            lottieSize = 150;
        } else if (window.innerWidth <= 350) {
            lottieSize = 180;
        } else if (window.innerWidth <= 400) {
            lottieSize = 250;
        }

        let topPadding = (window.innerHeight - (lottieSize + 100)) / 2 + "px";
        return (
            <div className="IveriLoadingDiv" style={{ paddingTop: topPadding }}>
                <Lottie options={defaultOptions}
                    height={lottieSize}
                    width={lottieSize}
                    isStopped={this.state.isStopped}
                    isPaused={this.state.isPaused}
                />
                <div className="p-4 text-center">
                    <h3 className="Success">Credit card details successfully added</h3>
                </div>
            </div>
        );
    }
}

export default connect()(IveriSuccessLoadingScreen)